module.exports = __webpack_public_path__ + "static/media/product_simplicity.1b2eecfd.svg";